import { LocalStyles } from "@paperbits/common/styles";

export class ProductSubscriptionsModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
